import React from 'react';
import { Tooltip } from 'antd';

const LifeCycleWrapper = ({ tooltipTitle, children }) => {
  return tooltipTitle ? (
    <Tooltip title={tooltipTitle}>{children}</Tooltip>
  ) : (
    children
  );
};

export default LifeCycleWrapper;
